import { render, staticRenderFns } from "./RSVPList.vue?vue&type=template&id=59fbca0b&"
import script from "./RSVPList.vue?vue&type=script&lang=js&"
export * from "./RSVPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports